"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Chip_1 = tslib_1.__importDefault(require("@mui/material/Chip"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const AutocompleteChip = (props) => {
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const isOpen = Boolean(anchorEl);
    const { renderPopoverContent, ...rest } = props;
    const handleToggle = (event) => setAnchorEl(event?.currentTarget || null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Popover_1.default, { open: isOpen, onClose: () => handleToggle(null), anchorEl: anchorEl, anchorOrigin: { vertical: "bottom", horizontal: "center" }, transformOrigin: { vertical: "top", horizontal: "center" } },
            react_1.default.createElement(Box_1.default, { sx: { p: 2 } }, renderPopoverContent())),
        react_1.default.createElement(Chip_1.default, { clickable: true, onClick: handleToggle, ...rest })));
};
exports.default = AutocompleteChip;
